module.exports = __webpack_public_path__ + "img/text.fcf9e864.png";